import { Utils } from '../../Core';
import { zipCodeApi as API } from '../../Apis';
import { mocksService } from './ZipCode.mock';
import dataFields from '../../Types/ZipCode.json';
import { IZipCodeServiceRequest } from '../../Types/ZipCode.types';

const prepareCall = (stateRequestParameters: IZipCodeServiceRequest) =>
  API.call.get({
    zipcode: stateRequestParameters?.zipcode,
  });

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
});
